<template>
  <div class="app-body">
    <StoreLogTable  query-type="receiver" :hide-columns="['receiverName','price','boxReceiptCode','totalReceiveCount']"
                   :hide-buttons="['receive','price','cancel']" :hide-query="['receiverName','status','orderCode','boxReceiptCode']" :default-query-params="{status:20}"></StoreLogTable>
  </div>
</template>

<script>
/**
 * 工厂端-收货记录列表
 */
import StoreLogTable from '@/views/modules/erp/common/store-log-table.vue'

export default {
  name: 'erp-receive-index',
  components: { StoreLogTable },
  data () {
    return {
      currentTab: 'purchase',
      cacheKey: 'erp:store:receive:tab'
    }
  },
  activated () {
    let localCurrentTab = window.localStorage.getItem(this.cacheKey)
    if (localCurrentTab) {
      this.currentTab = localCurrentTab
    }
  },
  watch: {
    currentTab (newVal) {
      window.localStorage.setItem(this.cacheKey, newVal)
    }
  },
  methods: {}
}
</script>

<style scoped>

</style>
